import React from "react";
import { ArrowUpIcon } from "lucide-react";

export default function InputBox({
  message,
  setMessage,
  onSubmit,
  isGenerating,
  demo,
  sampleQuery,
}: {
  message: string;
  setMessage: (message: string) => void;
  isGenerating: boolean;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  demo: boolean;
  sampleQuery: string
}) {
  return (
    <div className="fixed bottom-0 w-full flex justify-center pt-10">
      <form
        className="flex flex-col items-center justify-center min-w-[700px] max-w-[700px gap-4"
        onSubmit={onSubmit}
      >
        <div className="flex gap-2 w-full p-2 bg-gradient-to-t from-white via-white to-transparent bg-white border rounded-xl items-center" style={{
          boxShadow: '0px 4px 16px 0px #0000000D'}}>
          <input
            placeholder="Ask anything..."
            className="w-full bg-transparent p-2 focus:outline-none text-sm border-none focus:ring-0"
            onChange={(e) => {
              if (!demo) {
                setMessage(e.target.value);
              }
            }}
            onClick={(e) => {
              if (demo) {
                setMessage(sampleQuery)
              }
            }}
            value={message}
          />
          {<button
            disabled={!message || isGenerating}
            className={`p-2 rounded-full w-8 h-8 flex items-center justify-center transition-all duration-300 ${
              isGenerating ? "bg-black" : message ? "bg-black" : "bg-gray-200"
            }`}
          >
            {isGenerating ? (
              <div className="w-4 h-4 bg-white rounded-sm" />
            ) : (
              <ArrowUpIcon
                className={`w-4 h-4 ${message ? "text-white" : "text-gray-500"}`}
                strokeWidth={2.5}
              />
            )}
          </button>}
        </div>

        <span className="text-xs text-slate-500 mb-4 text-center w-full">
          AI can make mistakes. Check important info.
        </span>
      </form>
    </div>
  );
}
